import i18n from 'i18n';
import { ContentExplorerEntry, ContentLibrarySortBy } from 'features/content-library/types';

const collatorsByLanguage = new Map<string, Intl.Collator>();

const getCollator = () => {
  const { language } = i18n;
  let collator = collatorsByLanguage.get(language);

  if (!collator) {
    collator = new Intl.Collator(language, { numeric: true, sensitivity: 'base' });
    collatorsByLanguage.set(language, collator);
  }

  return collator;
};

// Date.parse('') is NaN, and a NaN comparator result makes sort order depend on input permutation
const toTime = (date: string) => {
  const time = Date.parse(date);

  return Number.isNaN(time) ? 0 : time;
};

const compareIds = (a: ContentExplorerEntry, b: ContentExplorerEntry) => {
  if (a.id === b.id) {
    return 0;
  }

  return a.id < b.id ? -1 : 1;
};

export const sortContentLibraryEntries = (
  entries: ContentExplorerEntry[],
  sortBy: ContentLibrarySortBy
): ContentExplorerEntry[] => {
  const collator = getCollator();
  const compareNames = (a: ContentExplorerEntry, b: ContentExplorerEntry) =>
    collator.compare(a.name, b.name);

  const comparator =
    sortBy === 'name'
      ? (a: ContentExplorerEntry, b: ContentExplorerEntry) => compareNames(a, b) || compareIds(a, b)
      : (a: ContentExplorerEntry, b: ContentExplorerEntry) =>
          toTime(b.date) - toTime(a.date) || compareNames(a, b) || compareIds(a, b);

  return [...entries].sort(comparator);
};
